import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const deleteComment = async (commentId: string) => {
  const [response, bodyOrError] = await Api.delete(`comments/${commentId}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useDeleteComment = () => {
  const queryClient = useQueryClient();

  return useMutation<Comment, Error, string>('deleteComment', deleteComment, {
    onSuccess: () => {
      queryClient.invalidateQueries('reportedComments');
    },
  });
};
